import { styled, Theme, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Chip from '@mui/material/Chip';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name: string, personName: readonly string[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const CustomMenuItem = styled(MenuItem)(({ theme, selected }) => ({
  borderRadius: theme.shape.borderRadius,
  border: '1px solid',
  borderColor: theme.palette.divider,
  margin: theme.spacing(0.5),
  backgroundColor: selected ? '#3860B2' : 'inherit',
  color: selected ? '#ffffff' : 'inherit',
  '&.Mui-selected': {
    backgroundColor: '#3860B2 !important',
    color: '#ffffff !important',
  },
  '&:hover': {
    backgroundColor: selected ? '#3860B2' : theme.palette.action.hover,
  },
}));

interface SelectAnalisesProps {
  selectedAnalises: string[];
  onChange: (event: SelectChangeEvent<string[]>) => void;
  names: string[]
}

export default function SelectAnalises({
  names,
  selectedAnalises,
  onChange,
}: SelectAnalisesProps) {
  const theme = useTheme();

  return (
    <div>
      <FormControl fullWidth>
        <Select
          required
          multiple
          value={selectedAnalises}
          onChange={onChange}
          input={<OutlinedInput id="select-multiple-chip" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <CustomMenuItem
              key={name}
              value={name}
              style={getStyles(name, selectedAnalises, theme)}
            >
              {name}
            </CustomMenuItem>
          ))}
          <CustomMenuItem
            key="Outras"
            value="Outras"
            style={getStyles("Outras", selectedAnalises, theme)}
          >
            Outras
          </CustomMenuItem>
        </Select>
      </FormControl>
    </div>
  );
}
